import { createAction } from 'redux-actions'
import axios from 'axios';

// 获得用户兑换列表
export const getScoreExchangeSucceeded = createAction('scoreExchange/GET_SUCCEEDED')
export const getScoreExchangeFailed = createAction('scoreExchange/GET_FAILED')

export function fetchGetScoreExchange(params) {
  return (dispatch) => {
    console.log();
    return axios.get('/api/find/exchange', { params })
      .then(response => dispatch(getScoreExchangeSucceeded(response)))
      .catch(error => dispatch(getScoreExchangeFailed(error)))
  }
}

// 确认收货
export const confirmSucceeded = createAction('confirm/GET_SUCCEEDED')
export const confirmFailed = createAction('confirm/GET_FAILED')

export function fetchconfirm(id) {
  return dispatch => (
    axios.get(`/api/confirm/${id}`)
      .then(response => dispatch(confirmSucceeded(response)))
      .catch(error => dispatch(confirmSucceeded(error)))
  )
}

// 导出用户兑换列表
export const getScoreExchangeExportRequested = createAction('scoreExchangeExport/GET_REQUESTED')
export const getScoreExchangeExportSucceeded = createAction('scoreExchangeExport/GET_SUCCEEDED')
export const getScoreExchangeExportFailed = createAction('scoreExchangeExport/GET_FAILED')

export function fetchGetScoreExchangeExport(params) {
  return (dispatch) => {
    dispatch(getScoreExchangeExportRequested);
    return axios.get('/api/find/Excel', { params })
      .then(response => dispatch(getScoreExchangeExportSucceeded(response)))
      .catch(error => dispatch(getScoreExchangeExportFailed(error)));
  }
}



// WEBPACK FOOTER //
// ./actions/scoreExchange.js